import Api from "../../api/api"
import i18n from '../../translations/i18n'

class NewsController {
    GetAll = async (callback) => {
        callback.init()
        const response = await Api.GET(`/news/language/${Api.GetLanguage()}`)

        if(response.status === true){
            return callback.success(response)
        }
        return callback.error(response)
    }
}

export default NewsController